import { Form, Input, Modal, Radio, Select, DatePicker, message } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import React, { useContext, useEffect, useState } from "react";
import { BUTTON_PROPS } from "../../constants/general";
import AppContext from "../../context/app.context";
import { IAppContext } from "../../interfaces/context.interfaces";
import { IProject, IServerEvent, IUser } from "../../interfaces/map.interfaces";
import MapDataContext from "../MapData/map.data.context";
import { IDeckGlInfoObject } from "./deck.gl.map";
import UploadImage from "./UploadImage";
import moment, { Moment } from "moment";
import {
  canShowStations,
  getHanEventTypes,
  isHanProject,
  STATION_EVENT_TYPE,
} from "../../utils/station.utils";

function AddNewEvent({
  event,
  enabled,
  setEnableHeli,
  refreshEvents,
}: {
  event: IDeckGlInfoObject;
  enabled: boolean;
  setEnableHeli : Function
  refreshEvents: Function;
}) {
  const appContext: IAppContext = useContext(AppContext);

  const [user, setUser] = useState<IUser>();
  const [project, setProject] = useState<IProject>();
  const [visible, setVisible] = useState<boolean>(enabled);
  const [initialClick, setInitialClick] = useState(true);
  const [count, setCount] = useState(0);

  const [newEventState, setNewEventState] = useState<string>();
  const [newTypeState, setNewTypeState] = useState<string>();
  const [detectedBy, setDetectedBy] = useState<string>();
  const [code, setcode] = useState<string>();
  const [newSubTypeState, setNewSubTypeState] = useState<string>();
  const [newEventDate, setNewEventDate] = useState<any>(null);
  const [newEventComment, setNewEventComment] = useState<string>("");
  const [newEventAuthor, setNewEventAuthor] = useState<string>();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<UploadFile>(null);
  const [embeddedApp, setEmbeddedApp ] = useState<boolean>(false)
  const { Option } = Select;

  const language = user?.language;

  useEffect(() => {
    appContext.services.userService.getMyData().then((data) => {
      setUser(data.data);
      setNewEventAuthor(data.data?.email || "");
    });
    appContext.services.projectService.getMyData().then((data) => {
      setProject(data.data[0]);
    });
    if (appContext.projects?.app === "svi" || appContext.projects?.app === "red") {
      setEmbeddedApp(true)
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setInitialClick(true);
      setCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    if (!event) return;
    setVisible(true);
    enabled && setCount(count + 1);
  }, [event]);

  useEffect(() => {
    if (count > 1) {
      setInitialClick(false);
    }
  }, [count]);

  useEffect(() => {
    if (!visible) return;
    setNewSubTypeState("");
    setNewTypeState("");
    setNewEventState("");
  }, [event, visible]);

  if (event.object) return null;

  const DetectedByOptions =
  language === "de"
    ? ["Alle", "Helikopter", "Satellit", "Drohne", "Andere"]
    : ["All", "Helicopter", "Satellite", "Drone", "Others"];

  const getDetectedByOptions = () => {
  const options =
    language === "de"
      ? [
          { label: "Alle", value: "All" },
          { label: "Helikopter", value: "Helicopter" },
          { label: "Satellit", value: "Satellite" },
          { label: "Drohne", value: "Drone" },
          { label: "Andere", value: "Others" },
        ]
      : [
          { label: "All", value: "All" },
          { label: "Helicopter", value: "Helicopter" },
          { label: "Satellite", value: "Satellite" },
          { label: "Drone", value: "Drone" },
          { label: "Others", value: "Others" },
        ];

  return options.map((opt) => (
    <Option key={opt.value} value={opt.value}>
      {opt.label}
    </Option>
  ));
};

  const getOptions = (options: string[]) => {
    let optionsArr = [];
    const typeOptions = isHanProject(project?.id) && canShowStations()
      ? getHanEventTypes(options)
      : options;
    if (typeOptions) {
      for (const option of typeOptions) {
        optionsArr.push(
          <Option key={option} value={option}>
            {option}
          </Option>
        );
      }
    }

    return optionsArr;
  };

  const isStationType = newTypeState === STATION_EVENT_TYPE;

  const onAddEvent = async (event: IServerEvent) => {
    if (!appContext) {
      return;
    }
    try {
      let data: any;
      if (embeddedApp) {
        if (appContext.projects?.app === "svi") {
          data = await appContext.services.sviEventService.addHeliEvent(event);
        } else if (appContext.projects?.app === "red") {
          data = await appContext.services.liaEventService.addHeliEvent(event);
        }
      } else {
        data = await appContext.services.eventService.addHeliEvent(event);
      }

      if (imageFile?.originFileObj) {
        const stationSelected =
          event.properties.type === STATION_EVENT_TYPE;
        const uploadKey = stationSelected
          ? data?.data?.properties?.images?.[0]?.key ||
            `${data?.data?.properties?.id}.png`
          : `${data?.data?.properties?.id}.png`;
        appContext.services.imageService.uploadImage(
          imageFile.originFileObj as File,
          uploadKey
        );
      }

      setTimeout(() => {
        refreshEvents();
      }, 1000);
      message.success(
        language === "de"
          ? "Ereignis erfolgreich erstellt."
          : "Event created successfully."
      );
    } catch (error) {
      message.error(
        language === "de"
          ? "Ereignis konnte nicht erstellt werden."
          : "Failed to create event."
      );
    }

  };

  const handleOk = (event: IDeckGlInfoObject) => {
    setConfirmLoading(true);
    setTimeout(() => {

      let newEvent : IServerEvent
      const eventDate = newEventDate
        ? newEventDate.format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      const stationSelected = newTypeState === STATION_EVENT_TYPE;

      if (embeddedApp) {
        newEvent = {
        properties: {
          id: "",
          locationId: "",
          type: newTypeState,
          sourcetype: "heli",
          subType: newSubTypeState,
          comment: newEventComment,
          state: newEventState,
          code:code,
          date: eventDate,
          author: newEventAuthor,
          projectId: project?.id,
          image: stationSelected ? "" : imageFile ? "_" : "",
          detectedBy: stationSelected ? "Others" : detectedBy,
          ...(stationSelected && imageFile
            ? {
                hasImage: true,
                imageName: newEventComment,
              }
            : {}),
        },
        geometry: {
          type: "Point",
          coordinates: event.coordinate,
        },
      };
      } else {
        newEvent = {
        properties: {
          id: "",
          locationId: "",
          type: newTypeState,
          sourcetype: "heli",
          subType: newSubTypeState,
          comment: newEventComment,
          state: newEventState,
          date: eventDate,
          author: newEventAuthor,
          projectId: project?.id,
          image: stationSelected ? "" : imageFile ? "_" : "",
          detectedBy: stationSelected ? "Others" : detectedBy,
          ...(stationSelected && imageFile
            ? {
                hasImage: true,
                imageName: newEventComment,
              }
            : {}),
        },
        geometry: {
          type: "Point",
          coordinates: event.coordinate,
        },
      };
      }
      

      onAddEvent(newEvent);

      setVisible(false);
      setConfirmLoading(false);
    }, 2000);
    setNewSubTypeState("");
    setNewTypeState("");
    setDetectedBy("")
    setNewEventState("");
    setNewEventDate(null);
    setNewEventComment("");
    setImageFile(null);
    setEnableHeli(false)
  };

  const handleCancel = () => {
    setNewSubTypeState("");
    setNewTypeState("");
    setDetectedBy("")
    setNewEventState("");
    setNewEventDate(null);
    setNewEventComment("");
    setVisible(false);
    setImageFile(null);
    setEnableHeli(false)
  };

  return (
    <Modal
      title={language === "de" ? "Bearbeiten" : "Edit"}
      className="MapDeckComment"
      centered
      okText={language === "de" ? "Einfügen" : "Submit"}
      cancelText={language === "de" ? "Abbrechen" : "Cancel"}
      visible={visible && enabled && !initialClick}
      onOk={() => {
        handleOk(event);
      }}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      okButtonProps={{
        type: "primary",
        shape: "round",
        size: "small",
        disabled:
          !newEventState ||
          !newTypeState ||
          !newEventComment
      }}
      cancelButtonProps={{
        ...BUTTON_PROPS,
        type: "danger",
        shape: "round",
        size: "small",
      }}
    >
      <Form onClick={(e) => e.stopPropagation()}>
        <Form.Item label={language === "de" ? "Status" : "State"}>
          <Radio.Group
            defaultValue={newEventState}
            onChange={(e) => setNewEventState(e.target.value)}
            value={newEventState}
          >
            <Radio.Button value={"active"}>
              {language === "de" ? "Aktiv" : "Active"}
            </Radio.Button>
            <Radio.Button value={"only report change"}>
              {language === "de" ? "Nur Änderung Melden" : "Only Report Change"}
            </Radio.Button>
            <Radio.Button value={"archived"}>
              {language === "de" ? "Archiv" : "Archive"}
            </Radio.Button>
            <Radio.Button value={"do not report"}>
              {language === "de" ? "Nicht Mehr Melden" : "Do Not Report"}
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item label={appContext?.projects?.app === "red" ? "Event Type" : language === "de" ? "Event Typ" : "Event Type"}>
          <Select
            style={{ width: 200 }}
            defaultValue={newTypeState}
            onChange={(value) => setNewTypeState(value)}
            value={newTypeState}
          >
            {getOptions(project?.types)}
          </Select>
        </Form.Item>
        {!isStationType ? (
        <Form.Item label={appContext?.projects?.app === "red" ? "Data Source" : language === "de" ? "Erkannt durch" : "Detected By"}>
          <Select
            style={{ width: 200 }}
            defaultValue={detectedBy}
            onChange={(value) => setDetectedBy(value)}
            value={detectedBy}
          >
            {getDetectedByOptions()}
          </Select>
        </Form.Item>
        ) : null}
        <span hidden={!project?.subTypeEnabled}>
          <Form.Item label={language === "de" ? "Sub Typ" : "SubType"}>
            <Select
              style={{ width: 200 }}
              defaultValue={newSubTypeState}
              onChange={(value) => setNewSubTypeState(value)}
              value={newSubTypeState}
            >
              {getOptions(project?.subTypes)}
            </Select>
          </Form.Item>
        </span>
        <Form.Item label={language === "de" ? "Datum" : "Date"}>
          <DatePicker
            style={{ width: "100%" }}
            value={newEventDate}
            onChange={(date) => setNewEventDate(date)}
            format="YYYY-MM-DD"
          />
        </Form.Item>
        <Form.Item label={language === "de" ? "Kommentar" : "Comment"}>
          <Input
            placeholder={
              language === "de"
                ? "Schreiben Sie Ihren Kommentar..."
                : "Write your comment..."
            }
            value={newEventComment}
            onChange={(e) => setNewEventComment(e.target.value)}
          />
        </Form.Item>
        {embeddedApp && appContext?.projects?.app !== "red" ? <Form.Item label={language === "de" ? "Code" : "Code"}>
          <Input
            placeholder={
              language === "de"
                ? "Code"
                : "Code"
            }
            value={code}
            onChange={(e) => setcode(e.target.value)}
          />
        </Form.Item> :null}
        <Form.Item label={language === "de" ? "Bearbeiter" : "Editor"}>
          <Input
            placeholder={language === "de" ? "Name des Autors" : "Author Name"}
            value={newEventAuthor}
            onChange={(e) => setNewEventAuthor(e.target.value)}
          />
        </Form.Item>
      </Form>
      <UploadImage
        setFile={setImageFile}
        file={imageFile?.originFileObj as File}
      />
    </Modal>
  );
}

export default AddNewEvent;
